import { useEffect, useState } from 'react';
import api from '@/lib/api';

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get('/admin/customers').then((r) => setCustomers(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-5">
      <h1 className="font-heading text-3xl text-stone-900">Customers</h1>
      {loading ? <p className="text-sm text-stone-500">Loading…</p> : customers.length === 0 ? (
        <p className="text-sm text-stone-500">No registered customers yet. (Most orders come from guest checkouts.)</p>
      ) : (
        <div className="bg-white border border-stone-200 rounded-2xl overflow-x-auto">
          <table className="w-full text-sm min-w-[500px]">
            <thead className="bg-cream-100"><tr className="text-left text-stone-500 text-xs uppercase tracking-wider"><th className="py-3 px-4">Name</th><th className="px-3">Email</th><th className="px-3">Phone</th><th className="px-3">Joined</th></tr></thead>
            <tbody>
              {customers.map((c) => (
                <tr key={c.id} className="border-t border-stone-100">
                  <td className="py-2.5 px-4 font-medium">{c.name || '—'}</td>
                  <td className="px-3 text-stone-600">{c.email}</td>
                  <td className="px-3 text-stone-600">{c.phone || '—'}</td>
                  <td className="px-3 text-stone-500 text-xs">{c.created_at ? new Date(c.created_at).toLocaleDateString('en-IN') : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
